<svelte:options runes={false} />
<script>
  // The policy-replay A/B scoreboard (TASK-K2T-15): executed policies side by side over the read
  // window. The MEDIAN headlines (robust to one bad print); positive IS = cost (adverse), so the
  // sign carries the verdict and color only reinforces it. Unmeasured executions are counted but
  // never averaged — n(measured) is printed so a thin sample can't masquerade as a verdict.
  import { fmtBps, bpsTone, policyLabel } from '../../../lib/tca.js';
  import { formatNum } from '../../../lib/lineage.js';

  export let buckets = [];

</script>

{#if (buckets ?? []).length === 0}
  <div class="empty-state"><p class="empty-state-description">No executions in the window yet.</p></div>
{:else}
  <div class="tca-board">
    {#each buckets as b (b.policy)}
      <div class="tca-bucket">
        <span class="tca-bucket-policy">{policyLabel(b.policy)}</span>
        <span class="tca-bucket-headline num {bpsTone(b.medianIsArrivalBps)}">{fmtBps(b.medianIsArrivalBps)} <span class="tca-unit">bps</span></span>
        <span class="tca-bucket-sub">median IS at arrival · {b.measured}/{b.executions} measured</span>
        <div class="tca-bucket-rows">
          <span class="tca-kv"><span>mean</span><span class="num {bpsTone(b.avgIsArrivalBps)}">{fmtBps(b.avgIsArrivalBps)} bps</span></span>
          <span class="tca-kv"><span>total cost</span><span class="num">{b.totalIsQuote != null ? formatNum(b.totalIsQuote, 2) : '—'}</span></span>
          <span class="tca-kv"><span>drift +5m</span><span class="num">{fmtBps(b.avgDrift5mBps)} bps</span></span>
        </div>
      </div>
    {/each}
  </div>
{/if}

<style>
  .tca-board { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 0.6rem; }
  .tca-bucket {
    display: flex; flex-direction: column; gap: 0.2rem;
    border: 1px solid var(--border-subtle, #1e1f22); border-radius: 6px; padding: 0.6rem 0.7rem;
    background: var(--surface-1, rgba(255, 255, 255, 0.02));
  }
  .tca-bucket-policy { font-size: 0.66rem; text-transform: uppercase; letter-spacing: 0.05em; color: var(--text-muted, #8a8b8d); }
  .tca-bucket-headline { font-size: 1.15rem; font-weight: 700; color: var(--text-primary, #e8e9ea); }
  .tca-unit { font-size: 0.66rem; font-weight: 400; color: var(--text-muted, #8a8b8d); }
  .tca-bucket-sub { font-size: 0.62rem; color: var(--text-muted, #8a8b8d); }
  .tca-bucket-rows { display: flex; flex-direction: column; gap: 0.1rem; margin-top: 0.35rem; }
  .tca-kv { display: flex; justify-content: space-between; font-size: 0.7rem; color: var(--text-secondary, #b5b6b8); }
  .tca-adverse { color: var(--danger, #e0533a); }
  .tca-favorable { color: var(--success, #1aa260); }
  .num { font-variant-numeric: tabular-nums; }
</style>
